module.exports = __webpack_public_path__ + "static/media/menuObject.e380562c.svg";